import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdAppGroupPermissionSetsDeletePermissionSetIdCacheKeys: AllRouteEndpoints[] = [];
